
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.344 8.292L7.024 4.4m0 0l-1.512.164M7.023 4.4l.157 1.62","stroke":"#172542","stroke-width":".6"}}),_c('path',{attrs:{"d":"M3.165 8.791c.7.721 1.551 1.081 2.552 1.081 1.001 0 1.852-.36 2.552-1.08C8.97 8.07 9.32 7.195 9.32 6.165c0-1.03-.35-1.904-1.05-2.625-.701-.72-1.552-1.081-2.553-1.081-1 0-1.851.36-2.552 1.081-.7.72-1.051 1.596-1.051 2.625 0 1.03.35 1.905 1.05 2.625zm7.356 1.081l3.979 4.093-1.201 1.235-3.979-4.092v-.657l-.225-.231c-.95.85-2.077 1.274-3.378 1.274-1.451 0-2.69-.515-3.716-1.544C1.001 8.92.5 7.659.5 6.166c0-1.493.5-2.754 1.501-3.783C3.027 1.328 4.266.8 5.717.8s2.678.528 3.678 1.583c1.001 1.03 1.502 2.29 1.502 3.783 0 .54-.125 1.158-.376 1.853-.25.67-.538 1.21-.863 1.622l.225.231h.638z","fill":"#172542"}})])
          )
        }
      }
    